import React from 'react';
import { LegalPage } from './LegalPage';

export const CookiePage = () => <LegalPage page="cookie" />;
